module.exports = __webpack_public_path__ + "img/8.03c0f83b.svg";